import React, { useEffect, useState } from "react";
import ScreenshotsFilter from "../../modals/ScreenshotsFilter";
import ScreenshotDetectedText from "../../modals/ScreenshotDetectedText";
import DeleteSelectedScreenshot from "../../modals/DeleteSelectedScreenshot";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
// import { getCallRecord } from "../../../AxiosRtk/CallSms";
import { deleteKeyStroke, getKeyStrokeData } from "../../../AxiosRtk/KeyStroke";
import { isEmpty } from "lodash";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import { handleStartDateCommon } from "../../../../../utils/helper";
import Select from "react-select";
import useDurationOption from "../../../../customHooks/durationOption";
import useLangTranslation from "../../../../customHooks/languageProvider";
import DateFilter from "../../../../shared/DateFilter/DateFilter";

const KeystrokesActivityScreen = ({ selectedDeviceId }) => {
  const { ID: parentID } = useSelector(({ auth }) => auth.user);
  const dispatch = useDispatch();
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const [selectedScreenshots, setSelectedScreenshots] = useState([]);
  const [screenshotListData, setScreenshotListData] = useState([]);
  const [selectToBeDeleted, setSelectToBeDeleted] = useState(0);
  const [deletedSelectedModal, setDeletedSelectedModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const { getLangTranslation } = useLangTranslation();
  const [filterData, setFilterData] = useState({
    selectedPackages: [],
    selectedCategoryIds: [],
    selectedKeyWords: [],
  });
  const [detectedTextModal, setDetectedTextModal] = useState(false);

  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);

  const handleSelectAllChange = () => {
    if (
      selectedScreenshots.length > 0 ||
      selectedScreenshots.length === screenshotListData.length
    ) {
      setSelectedScreenshots([]);
    } else {
      const temp = [];
      screenshotListData.forEach((item) =>
        item.keystroke_info.forEach((itm, ind) => temp.push(itm.ID))
      );
      setSelectedScreenshots(temp);
    }
  };
  const handleCheckboxChangeForOneCompleteStroke = (strokeId) => {
    const temp = [];
    screenshotListData.forEach((item) => {
      if (item?.ID == strokeId) {
        item.keystroke_info.forEach((itm, ind) => temp.push(itm.ID));
      }
    });
    if (selectedScreenshots.includes(strokeId)) {
      setSelectedScreenshots(
        selectedScreenshots.filter((id) => !temp.includes(id))
      );
    } else {
      setSelectedScreenshots([...selectedScreenshots, ...temp]);
    }
  };
  const handleCheckboxChange = (strokeId) => {
    if (selectedScreenshots.includes(strokeId)) {
      setSelectedScreenshots(
        selectedScreenshots.filter((id) => id !== strokeId)
      );
    } else {
      setSelectedScreenshots([...selectedScreenshots, strokeId]);
    }
  };
  const handleSelectToBeDeletedCheckbox = () => {
    setSelectToBeDeleted((prevValue) => (prevValue === 0 ? 1 : 0));
  };

  const openDeletedSelected = () => {
    setDeletedSelectedModal(true);
  };
  const closeDeletedSelected = () => {
    setDeletedSelectedModal(false);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const openDetectedTextModal = () => {
    setDetectedTextModal(true);
  };
  const closeDetectedTextModal = () => {
    setDetectedTextModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  function getKeyStrokeHistory() {
    if (selectedDeviceId && startDate) {
      const obj = {
        kidId: selectedKidId,
        deviceId: selectedDeviceId,
        activityType: "KEY_STROKES",
        startDate: startDate,
        endDate: endDate,
        pageNo: 1,
        itemsPerPage: 20000,
        isDeletedImages: selectToBeDeleted,
      };

      const packageName = filterData ? filterData?.selectedPackages : "";

      if(packageName) {
        obj.appPackageNames = packageName
      }

      getKeyStrokeData(obj)
        .then((res) => {
          setScreenshotListData(res?.data?.result);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  useEffect(() => {
    getKeyStrokeHistory();
  }, [
    startDate,
    endDate,
    selectedDeviceId,
    selectToBeDeleted,
    filterData.selectedKeyWords,
    filterData.selectedPackages,
  ]);

  useEffect(() => {
  }, [selectedScreenshots]);

  const handleDelete = async (type) => {
    if (!isEmpty(selectedScreenshots)) {
      const payload = {
        keystrokeActivityId: selectedScreenshots.toString(),
        activityType: "KEY_STROKES",
        deviceId: selectedDeviceId,
        isDeleteAll: 0,
        isAlertDelete: 0,
        // type: type,
      };
      try {
        const { data } = await deleteKeyStroke(payload);
        if (data) {
          setTimeout(()=>{ dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: data?.message,
              message: data?.message,
            })
          )},800)
          
          closeDeletedSelected();
          setSelectedScreenshots([]);
          getKeyStrokeHistory();
        }
      } catch (error) {
        closeDeletedSelected();
        console.log(error);
      }
    }
  };

  function getScreenshot(imgUrl) {
    if (imgUrl?.includes("https:")) {
      return imgUrl;
    }

    return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW}/${btoa(
      parentID
    )}/Nudity/thumbnail/${imgUrl}`;
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
        <div className="d-flex align-items-center flex-wrap gap-6">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              name="allSelect"
              id="selectAll"
              checked={
                selectedScreenshots.length > 0 &&
                selectedScreenshots.length ===
                  screenshotListData.reduce(
                    (prev, curr) => (prev = prev + curr.keystroke_info.length),
                    0
                  )
              }
              onChange={handleSelectAllChange}
            />
            <label className="form-check-label text-dark" htmlFor="selectAll">
              {getLangTranslation("KEYSTROKE_SELECT_ALL", "Select All")}
            </label>
          </div>
          <button
            className="btn btn-outline-primary"
            type="button"
            onClick={openDeletedSelected}
          >
            {getLangTranslation(
              "KEYSTROKE_BUTTON_DELETE_SELECTED",
              "Delete selected"
            )}
          </button>
        </div>
        <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
          <DateFilter
            startDate={startDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            selectedDuration={selectedDuration}
          />
          <Select
            className="custom-select col-lg-4"
            classNamePrefix="custom-select"
            placeholder="Select"
            onChange={(val) => {
              handleStartDateCommon(
                val,
                setStartDate,
                setSelectedDuration,
                setEndDate
              );
            }}
            options={durationOptions}
            value={
              durationOptions?.find(
                (item) => item?.value == selectedDuration
              ) || ""
            }
          />
          <span className="icon-wrap pt-cursor bg-gray-300" onClick={openModal}>
            <i className="icon-filter" />
          </span>
        </div>
      </div>

      {screenshotListData?.map((item) => (
        <div className="card mb-6">
          <div className="card-body">
            <div className="d-flex align-items-center gap-3">
              <span className="icon-wrap icon-blue border-0">
                <img src={item?.image} alt="Instagram" />
              </span>
              <h6 className="my-0 flex-grow-1 text-blue-900">
                {item?.AppName}
              </h6>
              <input
                className="form-check-input"
                id="enableScreenshot"
                type="checkbox"
                checked={selectedScreenshots.includes(item.ID)}
                onChange={() =>
                  handleCheckboxChangeForOneCompleteStroke(item.ID)
                }
              />
            </div>
            {item?.keystroke_info?.map((stroke, strokeIndex) => (
              <>
                <hr className="my-3" />
                <div className="d-flex align-items-center gap-3">
                  <div className="flex-grow-1">
                    <p className="mb-0 text-small text-blue-900 fw-semibold">
                      {stroke?.keystrokeText}
                    </p>
                    <span className="text-small">{moment(stroke?.StrokeTime).utc().format("YYYY-MM-DD HH:mm")}</span>
                  </div>
                  <input
                    className="form-check-input"
                    id="enableScreenshot"
                    type="checkbox"
                    checked={selectedScreenshots.includes(stroke.ID)}
                    onChange={() => handleCheckboxChange(stroke.ID)}
                  />
                </div>
              </>
            ))}
          </div>
        </div>
      ))}

      <ScreenshotsFilter
        showModal={showModal}
        closeModal={closeModal}
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <ScreenshotDetectedText
        showModal={detectedTextModal}
        closeModal={closeDetectedTextModal}
        getScreenshot={getScreenshot}
      />
      <DeleteSelectedScreenshot
        selectedDeviceId={selectedDeviceId}
        selectedScreenshots={selectedScreenshots}
        showModal={deletedSelectedModal}
        closeModal={closeDeletedSelected}
        handleDelete={handleDelete}
        onlyFirstOption={true}
      />
    </>
  );
};

export default KeystrokesActivityScreen;
